import { AxiosResponse } from 'axios';
const asyncHandler = async (request: Promise<AxiosResponse>) => {
  try {
    return await request;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default asyncHandler;
